import { defineComponent as _defineComponent } from 'vue'
import AccountHeader from './shared/AccountHeader.vue';
import ChangeStoreSideMenu from 'JS/components/side-menus/change-store/ChangeStoreSideMenu.vue';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import FullScreenLoader from 'JS/components/FullScreenLoader.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import Subscription from './subscriptions/Subscription.vue';
import SubscriptionLearnMoreSlideout from 'JS/subscriptions/shared/components/SubscriptionLearnMoreSlideout.vue';
import SubscriptionService from 'JS/services/SubscriptionService';
import TransitionFade from 'JS/components/transitions/TransitionFade.vue';
import {  computed, onMounted, ref, watch } from 'vue';
import { DEFAULT_GLOBAL_ERROR_MESSAGE } from 'JS/constants/errors';
import { ILocalStoreJson } from "JS/types/LocalStore";
import { SubscriptionOverview } from 'JS/types/subscription';
import { useEventListener } from 'JS/composables/event-listener';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionApp',
  setup(__props) {

const parentLoading = ref(false);
const childLoading = ref(false); //separate so as not to allow child loader to override parent
const loading = computed<boolean>(() => parentLoading.value == true || childLoading.value == true);
const _subscriptionService = new SubscriptionService();
const activeSubscriptions = ref<SubscriptionOverview[]>([]);
const localStore = ref<ILocalStoreJson>();
const showChangeStore = ref(false);
const showErrorMessage = ref(false);
const errorMessage = ref(DEFAULT_GLOBAL_ERROR_MESSAGE);
const farmsLandingLink = ref("");
const lastUpdatedSubscription = ref<{id: number, values: string[], prevIdOrder: number[]}>(null);

onMounted(() => {
	const url = new URL(window.location.href);
	if (url.pathname.endsWith('subscriptions/')) {
		getActiveSubscriptions();
	}
});

useEventListener(window, 'accounttabchange', e => {
	const url = new URL(window.location.href);

	if (e.detail.startsWith('subscriptions') && url.pathname.endsWith(e.detail) && !parentLoading.value) {
		getActiveSubscriptions();
	}
});

async function getActiveSubscriptions() {
	parentLoading.value = true;
	const response = await _subscriptionService.getActiveSubscriptions();
	if (lastUpdatedSubscription.value?.values.includes('order confirmation date'))  {
		unsortSubscriptions(response?.subscriptions);
	} else {
		activeSubscriptions.value = response?.subscriptions;
	}
	localStore.value = response?.localStore;
	farmsLandingLink.value = response?.farmsLandingLink;
	parentLoading.value = false;
}

function handleUpdateSubscriptions(update: {id: number, values: string[]}) {
	lastUpdatedSubscription.value = { ...update, prevIdOrder: activeSubscriptions.value.map(s => s.id) };
	getActiveSubscriptions();
}

function unsortSubscriptions(subs: SubscriptionOverview[]) {
	if (!subs || subs.length > lastUpdatedSubscription.value.prevIdOrder.length) {
		activeSubscriptions.value = subs;
		return;
	}

	const sortedSubscriptions = [];
	lastUpdatedSubscription.value.prevIdOrder.forEach((id) => {
		const foundSubscription = subs.find(s => s.id === id);
		if (foundSubscription) sortedSubscriptions.push(foundSubscription);
	});
	activeSubscriptions.value = sortedSubscriptions;
}

function handleStoreChanged() {
	window.location.reload();
}

function showHideChildLoader(show: boolean) {
	childLoading.value = show;
}

function showHideErrorMessage(show: boolean) {
	showErrorMessage.value = show;
}

const showDrawer = ref(false);
function openDrawer() {
	showDrawer.value = true;
}
function closeDrawer() {
	showDrawer.value = false;
}

return { __sfc: true,parentLoading, childLoading, loading, _subscriptionService, activeSubscriptions, localStore, showChangeStore, showErrorMessage, errorMessage, farmsLandingLink, lastUpdatedSubscription, getActiveSubscriptions, handleUpdateSubscriptions, unsortSubscriptions, handleStoreChanged, showHideChildLoader, showHideErrorMessage, showDrawer, openDrawer, closeDrawer, AccountHeader, ChangeStoreSideMenu, ErrorBanner, FullScreenLoader, LinkButton, Subscription, SubscriptionLearnMoreSlideout, TransitionFade }
}

})